import React, {memo} from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import messages from './messages';
import TicketsLeft from './TicketsLeft';
import {
  calculateTicketsLeftTier,
  calculateEventTimeframe,
  showTicketsLeft,
  calculateOnSaleTimeframe,
  showOnSale,
} from './utils';
import {TICKETS_LEFT_SHORT_VARIANTS, TICKETS_LEFT_LONG_VARIANTS} from './utils/constants';

import './index.scss';

const Urgency = ({
  messageFormatter,
  showUrgencyRewording = false,
  className,
  eventDateLocal,
  onSaleDate,
  totalTickets,
}) => {
  const FormattedMessage = messageFormatter;
  const addTotalTicketsBlock = showTicketsLeft(totalTickets);
  const addEventTimeframeBlock = !!eventDateLocal;
  const onSaleTimeframe = calculateOnSaleTimeframe(onSaleDate);
  const addOnSaleTimeframeBlock = showOnSale(onSaleTimeframe);

  const eventTimeFrame = addEventTimeframeBlock ? calculateEventTimeframe(eventDateLocal) : null;
  const ticketsLeftTier = addTotalTicketsBlock ? calculateTicketsLeftTier(totalTickets) : null;

  const TICKETS_LEFT_VARIANTS = showUrgencyRewording ? TICKETS_LEFT_LONG_VARIANTS : TICKETS_LEFT_SHORT_VARIANTS;

  return (
    <div className={classNames(className, 'urgency-msg-container')} data-date={addEventTimeframeBlock ? null : 'TBD'}>
      {addEventTimeframeBlock && eventTimeFrame && (
        <div className="urgency-msg-time-to-event" data-timeframe={eventTimeFrame}>
          <span>
            <FormattedMessage {...messages[`timeframe-${eventTimeFrame}`]} />
          </span>
        </div>
      )}
      {addOnSaleTimeframeBlock && (
        <div className="urgency-msg-on-sale" data-timeframe={onSaleTimeframe}>
          <span>
            <FormattedMessage id="urgency.onSale" defaultMessage="Recently on sale" />
          </span>
        </div>
      )}
      {addTotalTicketsBlock &&
        TICKETS_LEFT_VARIANTS.map((variant) => (
          <TicketsLeft
            key={variant}
            className={`urgency-msg-tickets-${variant}`}
            totalTickets={totalTickets}
            tier={ticketsLeftTier}
            message={messages[`tickets-${variant}`]}
            messageMany={messages[`tickets-${variant}-many`]}
            messageFormatter={messageFormatter}
          />
        ))}
    </div>
  );
};

Urgency.propTypes = {
  /** Custom classname to apply */
  className: PropTypes.string,

  /** Event local date in ISO format */
  eventDateLocal: PropTypes.string,

  /** On sale date for the event in ISO format*/
  onSaleDate: PropTypes.string,

  /** Total tickets left */
  totalTickets: PropTypes.number,

  /** Controls tickets left text variant */
  showUrgencyRewording: PropTypes.bool,

  /** The message formatter that should receive at least id and defaultMessage */
  messageFormatter: PropTypes.node.isRequired,
};

export default memo(Urgency);
